export const clientType = () => {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //IOS终端
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  const isHarmony = u.indexOf('OpenHarmony') > -1 //鸿蒙终端
  // const isHarmony = u.toLowerCase().indexOf('harmony') > -1
  if (isiOS) {
    return 'IOS'
  } else if (isAndroid) {
    return 'ANDROID'
  } else if (isHarmony) {
    return 'HARMONY'
  } else {
    return 'SYSTEM'
  }
}

export const fnGetHarmonyAppInfo = () => {
  // Mozilla/5.0 (Phone; OpenHarmony 5.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36  ArkWeb/4.1.6.1 Mobile _dsbridge fromappharmony sapp cVer=1.0.0
  const u = navigator.userAgent
  const oReg = /_dsbridge fromappharmony sapp cVer=(\d[.]\d[.]\d)/

  let cVer = ''
  let isHarmony = false

  if (oReg.test(u)) {
    cVer = RegExp.$1
    isHarmony = true
  }

  return {
    isHarmony,
    cVer,
  }
}

export const compareVersion = (v1, v2) => {
  v1 = v1.split('.')
  v2 = v2.split('.')
  let len = Math.max(v1.length, v2.length)
  while (v1.length < len) {
    v1.push('0')
  }
  while (v2.length < len) {
    v2.push('0')
  }
  for (let i = 0; i < len; i++) {
    let num1 = parseInt(v1[i])
    let num2 = parseInt(v2[i])
    if (num1 > num2) {
      return 1
    } else if (num1 < num2) {
      return -1
    }
  }
  return 0
}

export const fnCheckImg = (url: string) => {
  return new Promise((resolve) => {
    const oImg = new Image()
    oImg.onload = () => {
      resolve({ status: true, url })
    }
    oImg.onerror = () => {
      resolve({ status: false, url })
    }
    oImg.src = url
  })
}

export const fnFixedBg = (url) => {
  let sImg = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  if (url) {
    sImg = url
  }
  return {
    backgroundImage: `url(${sImg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 0',
    backgroundSize: 'contain',
    height: '100vh',
    position: 'fixed',
    width: '100vw',
    left: 0,
    top: 0,
  }
}

// App推荐渠道：A-规则推荐 B-自研 C-火山推荐 D-阿里推荐 E-AI Lab推荐

// 1.自研 B
// 2.阿里推荐 D
// 3.AI Lab E
// 4.火山推荐 C
// 5.规则推荐 A

export const oStrategyType = {
  A: '规则推荐',
  B: '自研',
  C: '火山推荐',
  D: '阿里推荐',
  E: 'AI Lab',
}
